import type { CustomComponent } from '../../config/types.js'

export type RowLabelComponent = CustomComponent

export type RowLabel = Record<string, string> | string
